<template>
    <BaseSection
        data-width="bleed"
        class="section--slider-cards section--small-title"
    >
        <template
            v-if="title"
            #title
        >
            {{ title }}
        </template>
        <template
            v-if="description"
            #description
        >
            <div v-html="description" /> <!-- eslint-disable-line -->
        </template>
        <CardSlider :items="posts" />
    </BaseSection>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    posts: {
        type: Array,
        required: true,
        default: null
    }
});
</script>
